import { format } from "date-fns";
import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

interface PayoutRequest {
  created_at: string;
  amount: number;
  status: string;
  provider: string;
}

interface PayoutRequestsProps {
  payoutRequests: PayoutRequest[];
  payoutAmount: number;
  onPayoutAmountChange: (amount: number) => void;
  onPayoutRequest: () => void;
}

export const PayoutRequests = ({
  payoutRequests,
  payoutAmount,
  onPayoutAmountChange,
  onPayoutRequest,
}: PayoutRequestsProps) => {
  return (
    <div className="space-y-4">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <h2 className="text-xl font-semibold">Payout Requests</h2>
        <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4 w-full sm:w-auto">
          <input
            type="number"
            value={payoutAmount}
            onChange={(e) => onPayoutAmountChange(Number(e.target.value))}
            className="border rounded px-3 py-2 w-full sm:w-32"
            placeholder="Amount"
          />
          <Button 
            onClick={onPayoutRequest}
            className="w-full sm:w-auto whitespace-nowrap"
          >
            Request Payout
          </Button>
        </div>
      </div>

      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Date</TableHead>
            <TableHead>Amount</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Provider</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {payoutRequests?.map((payout, index) => (
            <TableRow key={index}>
              <TableCell>
                {format(new Date(payout.created_at), 'MMM dd, yyyy')}
              </TableCell>
              <TableCell>${Number(payout.amount).toFixed(2)}</TableCell>
              <TableCell>
                <span className={`px-2 py-1 rounded-full text-xs ${
                  payout.status === 'completed' 
                    ? 'bg-green-100 text-green-800' 
                    : payout.status === 'pending'
                    ? 'bg-yellow-100 text-yellow-800'
                    : 'bg-red-100 text-red-800'
                }`}>
                  {payout.status}
                </span>
              </TableCell>
              <TableCell>{payout.provider}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};